// local storage keys
export const CAPACITY_OVERVIEW_FILTER_STORAGE_KEY = `capacity_overview_filters`;
export const CAPACITY_OVERVIEW_EYE_STORAGE_KEY = 'capacity_overview_eye_options';
